<template>
  <div class="input__primary text-left">
    <label class="pb-2 pt-5 flex justify-between" :for="id">
      <div>
        {{ label }}
        <span class="text-status-error" v-if="required && label">*</span>
      </div>
      <div v-if="counter">
        {{ inputVal ? inputVal.length : 0 }} / {{ maxLength }}
      </div>
      <slot name="label"></slot>
    </label>
    <div
      v-if="isDetail"
      class="p-2 bg-neutral-9 text-neutral-2 rounded-md flex place-items-center"
    >
      {{ inputVal }}
    </div>
    <textarea
      :class="`block w-full transition-all p-2 outline-none rounded-md`"
      :type="type"
      :id="id"
      v-else-if="type == 'textarea'"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      :name="name"
      v-on:input="inputVal = $event"
      :value="inputVal"
    />
    <input
      v-else
      :class="`block w-full transition-all p-2 rounded-md text-base`"
      :type="(type != 'number' && type) || 'text'"
      :id="id"
      min="0"
      :placeholder="placeholder"
      @keydown="handleKey($event)"
      :required="required"
      :disabled="disabled"
      :name="name"
      v-on:input="inputVal = $event"
      :value="inputVal"
    />
  </div>
</template>

<script>
export default {
  props: {
    /**
     * ID Wajib di isi, supaya ketika label di klik bisa otomatis focus input
     */
    id: {
      type: [String, Number],
      required: true,
    },
    /**
     * Tulisan yang ada diatas input persis.
     */
    label: {
      type: String,
      default: "",
    },
    /**
     * Text yang akan tampil apabila input kosong.
     */
    placeholder: {
      type: [String, Boolean],
      default: "",
    },
    /**
     * Type inputan, email, number, textarea
     */
    type: {
      type: String,
      default: "text",
    },
    /**
     * ketika benar maka muncul tanda bintang
     */
    required: {
      type: Boolean,
      default: false,
    },
    /**
     * ketika benar maka input jadi disable dan tidak bisa untuk input
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Lebih baik gunakan v-model daripada value
     */
    value: {
      type: [Number, String, Array, Boolean, Object],
      default: "",
    },
    /**
     * Validasi panjang karakter
     */
    maxLength: {
      type: [String, Number],
      default: "",
    },
    counter: {
      type: Boolean,
      default: false,
    },
    /**
     * Apabila benar ketika menginput huruf akan otomatis huruf besar
     */
    upperCase: {
      type: Boolean,
      default: false,
    },
    /**
     * Apabila benar ketika menginput huruf akan otomatis memblok spasi
     */
    blockSpace: {
      type: Boolean,
      default: false,
    },
    /**
     * Ketika benar, input menjadi mode detail, (tidak bisa input)
     */
    isDetail: {
      type: Boolean,
      default: false,
    },
    /**
     * Atribute nama
     */
    name: {
      type: String,
      default: "",
    },
    /**
     * Prefix toast message yang akan tampil
     */
    labelMessage: {
      type: String,
      default: "",
    },
    int: {
      type: Boolean,
      default: false,
    },
    phone: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valueHistory: false,
    };
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(event) {
        this.$emit("validation", event.target.value == "" ? null : event);
        /**
         * Untuk mendapatkan posisi select saat ini.
         */
        const start = event.target.selectionStart;
        let val = event.target.value;
        let spaceRemove = 0;

        /**
         * Auto convert ke huruf besar
         */
        if (this.upperCase) val = val.toUpperCase();

        /**
         * Blok spasi dalam input
         */
        if (this.blockSpace && val != val.replace(/\s/g, "")) {
          this.$toast.info(
            `${this.labelMessage || this.label} tidak boleh memuat spasi`,
          );
          val = val.replace(/\s/g, "");
          spaceRemove = 1;
        }

        /**
         * Validasi maksimal panjang karakter
         */
        if (this.maxLength && val.length > parseInt(this.maxLength)) {
          this.$toast.info(
            `${this.labelMessage || this.label} Maksimal ${
              this.maxLength
            } Karakter`,
          );
          if (this.upperCase)
            this.valueHistory = this.valueHistory.toUpperCase();
          val = this.valueHistory.toString().slice(0, parseInt(this.maxLength));
          spaceRemove = 1;
        }
        /**
         * Validasi hanya nomor 0-9
         */
        if (this.type == "number" && val != val.replace(/[^0-9]/g, "")) {
          val = val.replace(/[^0-9]/g, "");
          spaceRemove = 1;
          this.$toast.info("Hanya bisa memuat angka");
        }
        /**
         * Validasi hanya nomor 0-9,+,-,() untuk phone
         */
        if (this.phone && val != val.replace(/[^0-9|+|-|(|)|-]/g, "")) {
          val = val.replace(/[^0-9|+|-|(|)|-]/g, "");
          spaceRemove = 1;
          this.$toast.info("Hanya bisa memuat angka dan symbol +, -, ()");
        }

        /**
         * Konversi ke integer bila props int true
         */
        if (this.int) {
          val = parseInt(val) || val;
        }

        /**
         * Set Value yang sudah divalidasi ke input
         */
        event.target.value = val;

        /**
         * Set Histori Value
         */
        this.valueHistory = val;

        /**
         * Set posisi select
         */
        event.target.setSelectionRange(start, start - spaceRemove);

        console.log(
          "💻 Value: ",
          event.target.value,
          event.target.value == "" ? null : event.target.value,
        );

        /**
         * Emit value
         */
        this.$emit(
          "input",
          event.target.value == "" ? null : event.target.value,
        );
      },
    },
  },
  methods: {
    handleKey(event) {
      this.$emit("keydown", event);
    },
  },
  mounted() {
    /**
     * Inisialisai Histori value
     */
    this.valueHistory = this.inputVal;
  },
};
</script>

<style lang="scss">
.input__primary {
  input,
  textarea {
    @apply border;
    @apply border-transparent;
    outline: none;
  }
  input::placeholder {
    @apply text-base;
  }
  input:placeholder-shown {
    /* Your rules */
    @apply bg-neutral-9;
    @apply text-base;
  }
  input:focus {
    @apply border;
    @apply border-blue-primary;
  }
  input:disabled {
    @apply bg-neutral-9 cursor-not-allowed #{!important};
  }
  textarea:placeholder-shown {
    /* Your rules */
    @apply bg-neutral-9;
  }
  textarea:focus {
    @apply border;
    @apply border-blue-primary;
  }
  textarea:disabled {
    @apply bg-neutral-9 cursor-not-allowed #{!important};
  }
}
</style>
